module.exports = __webpack_public_path__ + "static/media/TrawloBanner1.4966e92d.png";